import { ProductListProvider } from '@/components/product-list-context';
import { ProductsSlider } from '@/components/ui/sliders';
function RelatedProducts({ isLoading, relatedProducts, title, list }) {
  return relatedProducts?.length > 0 ? (
    <div className='border-t-tertiary-50 mb-4 border-t max-lg:border-t'>
      <h2 className='mb-3 flex items-center pt-3 text-sm font-bold sm:text-base md:text-xl'>
        {title}
      </h2>
      <ProductListProvider list={list}>
        <ProductsSlider
          products={relatedProducts}
          isMutating={isLoading}
          fromPdp
        />
      </ProductListProvider>
    </div>
  ) : null;
}

export default RelatedProducts;
